import { type IUserWorkspace } from '@principle-theorem/shared';

export type IWorkspace = IUserWorkspace<WorkspaceType>;

export enum WorkspaceType {
  Organisation = 'organisation',
  Partner = 'partner',
}

export function isOrganisationWorkspace(
  workspace: IUserWorkspace
): workspace is IUserWorkspace<WorkspaceType.Organisation> {
  return String(workspace.type) === String(WorkspaceType.Organisation);
}

export function isPartnerWorkspace(
  workspace: IUserWorkspace
): workspace is IUserWorkspace<WorkspaceType.Partner> {
  return workspace.type === String(WorkspaceType.Partner);
}
